/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgHorizontalBarBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.5 22H22.5M6.4 11.2308H3.6C3.41435 11.2308 3.2363 11.3118 3.10503 11.4561C2.97375 11.6003 2.9 11.796 2.9 12V22H7.1V12C7.1 11.796 7.02625 11.6003 6.89497 11.4561C6.7637 11.3118 6.58565 11.2308 6.4 11.2308ZM13.4 2H10.6C10.4143 2 10.2363 2.08104 10.105 2.2253C9.97375 2.36956 9.9 2.56522 9.9 2.76923V22H14.1V2.76923C14.1 2.56522 14.0262 2.36956 13.895 2.2253C13.7637 2.08104 13.5857 2 13.4 2ZM20.4 6.61538H17.6C17.4143 6.61538 17.2363 6.69643 17.105 6.84069C16.9737 6.98495 16.9 7.1806 16.9 7.38462V22H21.1V7.38462C21.1 7.1806 21.0263 6.98495 20.895 6.84069C20.7637 6.69643 20.5857 6.61538 20.4 6.61538Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SvgHorizontalBar = wrapIcon(SvgHorizontalBarBase);
export default SvgHorizontalBar;
